import { Business, Engineering, Speed, Cloud } from '@mui/icons-material';

export const homeContent = {
  hero: {
    name: 'Kush Patel',
    title: 'Software Engineer & Technology Leader',
    location: 'Boston, MA',
    skills: [
      'Engineering Leadership',
      'Career Coaching',
      'Full Stack Development',
      'System Design',
      'Distributed Systems',
      'Cloud Computing',
      'Customer Obsessed',
      'Innovation',
      '0 to 1'
    ]
  },
  note: {
    text: 'NOTE: This entire bio page was built using Windsurf with no traditional coding or editing, only vibe coding commands to Cascade.'
  },
  about: {
    title: 'About Me',
    note: 'Written by Gemini using text input from me.',
    description: `As an Engineering Manager, I have over a decade of experience aligning technical innovation with business goals to deliver resilient systems and seamless user experiences. At athenahealth, I've spent the past 1.5 years advancing agile software development and optimizing engineering processes to deliver impactful solutions. Previously, at Flexcar, I enhanced financial technology systems, improving microservice stability to under 1% error rates and defining performance frameworks for team growth. One of my most notable achievements was at Wayfair, where I hired, designed, and delivered "Wayfair on Air," a 0 to 1 video shopping experience that prioritized user experience and became a highlight of Wayfair's 2022 Webby Award win. I'm experienced in managing multiple engineering teams and roadmaps, including overseeing both the Promotions and Wayfair on Air teams at Wayfair. My career began as an engineer at Worldpay, where I built the foundational skills necessary to develop high-availability systems, contributing to achieving the 99.999% uptime milestone twice. I excel at optimizing processes and workflows, consistently applying an engineering mindset to overcome obstacles and enhance performance within my teams and the broader organization.`
  },
  experience: {
    title: 'Experience',
    items: [
      { name: 'Athenahealth', path: '/athenahealth', icon: Engineering },
      { name: 'Flexcar', path: '/flexcar', icon: Speed },
      { name: 'Wayfair', path: '/wayfair', icon: Business },
      { name: 'WorldPay', path: '/worldpay', icon: Cloud },
      { name: 'Amazon Robotics', path: '/amazon-robotics', icon: Engineering }
    ]
  }
} as const;
